
import { NgIf } from '@angular/common';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { ModalDismissReasons, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css'],
  imports:[NgIf],
  standalone :true
})
export class ConfirmationDialogComponent implements OnInit {

  @Input() title!: string;
  @Input() message!: string;
  @Input() btnOkText!: string;
  @Input() btnCancelText!: string;

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal
  ) {
    // this.message = data.message;
  }

  ngOnInit(): void {
  }



  open(content: any) {
    const modalRef = this.modalService.open(content, {
      windowClass: 'custom-class'
    });
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}